export default "__VITE_ASSET__B3L1RMai__"